import { Grid } from "@mui/material";
import {
  FunctionField,
  Labeled,
  TextField,
  useRecordContext,
} from "react-admin";
import { GenderOptionsId, PersonIdTypes } from "utils/choices";
import DoctoralDateField from "../../Partials/DoctoralDateField";

const lookupName = (choices, id) => choices.find(c => c.id === id)?.name ?? "";

const PersonalInfo = () => {
  const record = useRecordContext();
  if (!record?.candidate) return null;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Labeled label="Име">
          <TextField source="candidate.firstName" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Презиме">
          <TextField source="candidate.secondName" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Фамилия">
          <TextField source="candidate.lastName" />
        </Labeled>
      </Grid>

      <Grid item xs={12} md={4}>
        <Labeled label="Име (латиница)">
          <TextField source="candidate.firstNameEn" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Презиме (латиница)">
          <TextField source="candidate.secondNameEn" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Фамилия (латиница)">
          <TextField source="candidate.lastNameEn" />
        </Labeled>
      </Grid>

      <Grid item xs={12} md={4}>
        <Labeled label="Идентификатор">
          <TextField source="candidate.personId" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Тип идентификатор">
          <FunctionField render={r => lookupName(PersonIdTypes, r?.candidate?.personIdType)} />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Пол">
          <FunctionField render={r => lookupName(GenderOptionsId, r?.candidate?.gender)} />
        </Labeled>
      </Grid>

      <Grid item xs={12} md={4}>
        <Labeled label="Дата на раждане">
          <DoctoralDateField source="candidate.birthDate" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Телефон за връзка">
          <TextField source="candidate.contactPhone" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={4}>
        <Labeled label="Имейл">
          <TextField source="candidate.email" />
        </Labeled>
      </Grid>
    </Grid>
  );
};

export default PersonalInfo;
